var map = {
	"./emprelatam-logo-invertido-transparente": 11,
	"./emprelatam-logo-invertido-transparente.png": 11,
	"./emprelatam-logo-transparente": 12,
	"./emprelatam-logo-transparente.png": 12,
	"./emprelatam-user-image": 13,
	"./emprelatam-user-image.png": 13,
	"./emprelatam_fondo": 14,
	"./emprelatam_fondo.png": 14,
	"./sign-in": 15,
	"./sign-in.png": 15,
	"./user_placeholder": 16,
	"./user_placeholder.svg": 16
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;